export default {
    apiKey: "AIzaSyA6t1xeZL3Mljyte0Eiit3Al8P-4FiPUXo",
    authDomain: "my-portal-e90f4.firebaseapp.com",
    databaseURL: "https://my-portal-e90f4.firebaseio.com",
    projectId: "my-portal-e90f4",
    storageBucket: "my-portal-e90f4.appspot.com",
    messagingSenderId: "521399144431"
}